import { STATS_API } from "@/lib/constants";
import { useAuth } from "@/providers/auth-provider";
import { useModal } from "@/providers/modal-provider";
import { useQuery } from "@tanstack/react-query";
import Link from "next/link";
import Skeleton from "react-loading-skeleton";
import { ProductHeading } from "../../product-heading";
import { ModalType } from "@/types/modal-type";

async function getStatsData() {
	const url = new URL(STATS_API);
	url.searchParams.set("query", "productsCount");

	const res = await fetch(url, { next: { revalidate: 600 } });
	if (!res.ok) {
		const { message } = await res.json();
		throw new Error(message);
	}

	const data = (await res.json()) as { productsCount: number };
	return data;
}

export const SubmitProductCard = () => {
	const { isLoggedIn } = useAuth();
	const { openModal } = useModal();

	const { isLoading, data = { productsCount: 0, usersCount: 0 } } = useQuery({
		queryKey: ["productsCount"],
		queryFn: getStatsData,
		refetchOnWindowFocus: false,
	});

	return (
		<div className="relative min-h-[384px] max-w-sm overflow-hidden rounded-lg bg-white p-6">
			<h3 className="break-words text-xl font-semibold text-gray-900">
				Amplify your product <span className="font-extrabold  text-brand-primary">Globally</span>
				{""} by launching it here!
			</h3>

			<div className="mt-6 flex flex-col gap-4">
				<ProductHeading
					title="Accacia"
					desc="AI-enabled SaaS platform"
					image="/images/dummy-logo-1.jpg"
				/>
				<ProductHeading
					title="Smart Clean"
					desc="Intelligent Cleaning management"
					image="/images/dummy-logo-2.png"
				/>
			</div>

			<div className="absolute inset-0 flex flex-col justify-end bg-gradient-to-t from-white from-5% via-white via-10% p-6">
				{isLoading ? (
					<Skeleton height={12} count={1} className="mb-4" />
				) : (
					<p className="pb-4 text-center text-xs font-semibold text-gray-800">
						<span className="text-brand-primary">{data.productsCount}+ products</span> submitted
						this month
					</p>
				)}
				{isLoggedIn ? (
					<Link
						href="/products/form/getting-started"
						className="w-full rounded-md bg-brand-primary p-3 text-center text-sm font-medium text-white"
						target="_blank"
					>
						Submit Your Product
					</Link>
				) : (
					<button
						onClick={() => openModal(ModalType.Auth)}
						className="w-full rounded-md bg-brand-primary p-3 text-center text-sm font-medium text-white"
					>
						Submit Your Product
					</button>
				)}
			</div>
		</div>
	);
};
